MoyaComponents.register('site.filter', (el) => {
	const buttons = el.querySelectorAll('.linksFilter a');
	const items = document.querySelectorAll('.documents__category .items .card__document');

	let selectedFilterCodename = '';

	function clearSelected(elements) {
		elements.forEach((element) => {
			element.classList.remove('selected');
		})
	}

	function updateItems() {
		items.forEach(item => {
			if (!selectedFilterCodename) {
				item.classList.remove('hidden');
				return;
			}

			if (item.classList.contains(selectedFilterCodename)) {
				item.classList.remove('hidden');
			} else {
				item.classList.add('hidden');
			}
		});
	}

	buttons.forEach((button) => {
		button.addEventListener('click', (ev) => {
			ev.preventDefault();

			if (button.classList.contains('selected')) {
				button.classList.remove('selected');
				selectedFilterCodename = '';
			} else {
				clearSelected(buttons);
				const clickedButtonCodename = button.getAttribute('href').replaceAll('#', '');
				button.classList.add('selected');
				selectedFilterCodename = clickedButtonCodename;
			}

			updateItems();
		});
	});
});
